import { Flex, Spacing } from '@billy/design-system'
import { ReactElement } from 'react'

import { AutomaticPaymentRemindersEmailBody } from './elements/AutomaticPaymentRemindersEmailBody'
import { AutomaticPaymentRemindersEmailSubject } from './elements/AutomaticPaymentRemindersEmailSubject'

export const AutomaticPaymentRemindersEmailFields = (): ReactElement | null => {
  return (
    <Flex flexDirection="column" gap={Spacing.S16}>
      <AutomaticPaymentRemindersEmailSubject />
      <AutomaticPaymentRemindersEmailBody />
    </Flex>
  )
}
